import { ErrorBoundary } from "react-error-boundary";
import { Route } from "react-router-dom";

import ClientViewpoint from "../../pages/administracao/clientes/modoEspelho";

export default function ClientRoute({
	pathName = "",
	colorMode = false,
	setColorMode = () => {},
}) {
	const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
	const isRouterNf = erp === "HUBSOFT" ? true : erp === "VOALLE" ? false : null;

	return (
		<Route element={<ClientViewpoint />}>
			{/* <Route
				element={
					<LayoutClient colorMode={colorMode} setColorMode={setColorMode} />
				}
			> */}
			{/* <Route
					path={`${pathName}/home`}
					element={
						<LayoutDashboardClient
							colorMode={colorMode}
							setColorMode={setColorMode}
						/>
					}
				>
					<Route
						path={`${pathName}/home/overview`}
						element={
							<ErrorBoundary
								FallbackComponent={({ error, resetErrorBoundary }) => (
									<ErrorPageConnection
										error={error}
										resetErrorBoundary={resetErrorBoundary}
									/>
								)}
								resetKeys={[`${pathName}/home/overview`]}
							>
								<OverviewClient />
							</ErrorBoundary>
						}
					/>
					<Route
						path={`${pathName}/home/saude`}
						element={
							<ErrorBoundary
								FallbackComponent={({ error, resetErrorBoundary }) => (
									<ErrorPageConnection
										error={error}
										resetErrorBoundary={resetErrorBoundary}
									/>
								)}
								resetKeys={[`${pathName}/home/saude`]}
							>
								<HealthClient />
							</ErrorBoundary>
						}
					/>
					<Route
						path={`${pathName}/home/disponibilidade`}
						element={
							<ErrorBoundary
								FallbackComponent={({ error, resetErrorBoundary }) => (
									<ErrorPageConnection
										error={error}
										resetErrorBoundary={resetErrorBoundary}
									/>
								)}
								resetKeys={[`${pathName}/home/disponibilidade`]}
							>
								<DisponibilidadeClient />
							</ErrorBoundary>
						}
					/>
					<Route
						path={`${pathName}/home/dash/sfp`}
						element={<DashSfpCliente />}
					/>
					<Route path={`${pathName}/home/onu`} element={<DashOnuCliente />} />
				</Route>
				<Route path={`${pathName}/financeiro`} element={<FinanceiroCliente />}>
					<Route
						path={`${pathName}/financeiro/faturas`}
						element={
							<ErrorBoundary
								FallbackComponent={({ error, resetErrorBoundary }) => (
									<ErrorPageConnection
										error={error}
										resetErrorBoundary={resetErrorBoundary}
									/>
								)}
								resetKeys={[`${pathName}/financeiro/faturas`]}
							>
								<Faturas />
							</ErrorBoundary>
						}
					/>
					{isRouterNf && (
						<Route
							path={`${pathName}/financeiro/nfs`}
							element={<NotaFiscal />}
						/>
					)}
				</Route>
				<Route
					path={`${pathName}/configuracoes`}
					element={<ConfiguracoesCliente />}
				/>

				<Route
					path={`${pathName}/tickets`}
					element={
						<ErrorBoundary
							FallbackComponent={({ error, resetErrorBoundary }) => (
								<ErrorPageConnection
									error={error}
									resetErrorBoundary={resetErrorBoundary}
								/>
							)}
							resetKeys={[`${pathName}/tickets`]}
						>
							<Tickets />
						</ErrorBoundary>
					}
				/>
				<Route
					path={`${pathName}/administracao`}
					element={
						<ProtectedRoute>
							<AdminUsuarioCliente />
						</ProtectedRoute>
					}
				/> */}

			{/* <Route path={`${pathName}/relatorios`} element={<RelatoriosCliente />}>
          <Route
            path={`${pathName}/relatorios/pdf`}
            element={<RelatorioFlowCliente />}
          />
          <Route
            path={`${pathName}/relatorios/percentil`}
            element={<PercentilCliente />}
          />
        </Route>
        <Route
          path={`${pathName}/relatorio`}
          element={<RelatorioAtaqueCliente />}
        >
          <Route
            path={`${pathName}/relatorio/agendamento`}
            element={<RelatorioAgendamentoCliente />}
          />
          <Route
            path={`${pathName}/relatorio/envio`}
            element={<RelatorioAtaqueEnvio />}
          />
        
        </Route> */}
			{/* <Route
					path={`${pathName}/relatorios`}
					element={<RelatoriosDisponiveisParaDownload />}
				/> */}
			{/* </Route> */}
		</Route>
	);
}
